<template>
  <div class="content">
    <div id="map_cn" :style="bgStyle" class="map_cn"></div>
    <div class="bgc map_but" @click="textShow = true">
      {{ mapBut }}
    </div>

    <el-dialog
      title="地图"
      :visible.sync="textShow"
      width="40vw"
      :append-to-body="true"
    >
      <el-image class="DTimg" :src="Bgimg" :fit="contain"></el-image>
    </el-dialog>
  </div>
</template>
 
<script>
import "../utils/hunan.js"; //这一步必须引入
import bus from "../utils/bus.js";

export default {
  props: {
    mapBut: {},
  },

  data() {
    return {
      mapId: "",
      myChart: null,
      //地图中的数据
      dataList: [],
      textShow: false,
      //指定图表的配置项和数据
      option: {
        series: [
          {
            map: "湖南",
            type: "map",
            aspectScale: 0.9,
            silent: true,
            // roam: false,
            data: this.dataList,
            itemStyle: {
              normal: {
                // 图形的描边颜色
                borderColor: "#000",
                // 描边线宽。
                borderWidth: 1,
                // 柱条的描边类型。
                borderType: "solid",
                // 图形的颜色 #233F53
                areaColor: "rgba(172, 172, 172, 0.705)",
                // 图形阴影的模糊大小。
                shadowBlur: 5,
                // 阴影色 #233F53
                shadowColor: "#rgba(255, 255, 255, 0)",
                // X轴阴影
                shadowOffsetX: 5,
                // Y轴阴影
                shadowOffsetY: 5,
                label: {
                  // 显示省份下面市、州的名称
                  show: true,
                  textStyle: {
                    color: "#fff",
                    fontSize: 16,
                  },
                },
              },
              // 鼠标放上去后，样式改变
              emphasis: {
                // 图形的描边颜色
                borderColor: "#rgba(255, 255, 255, 0)",
                borderWidth: "1",
                // 阴影色
                areaColor: "rgba(255, 255, 255, 0)",
                label: {
                  show: true,
                  textStyle: {
                    color: "rgba(255, 255, 255, 0)",
                    fontSize: 10,
                  },
                },
              },
              effect: {
                show: true,
                shadowBlur: 10,
                loop: true,
              },
            },
            // select: { // 地图选中区域样式
            //   label: { // 选中区域的label(文字)样式
            //     color: 'rgba(255, 255, 255, 0)'
            //   },
            //   itemStyle: {// 选中区域的默认样式
            //     areaColor: 'rgba(255, 255, 255, 0)'
            //   },
            // },
            layoutCenter: ["48%", "49.5%"], // 距离左右，上下距离的百分比
            layoutSize: "99%", // map百分比大小
          },
        ],
      },
      Bgimg: "",
    };
  },
  mounted() {
    this.mapBgimg();

    this.$bus.$on("regionList", (data) => {
      this.dataList = data;
    });

    this.$nextTick(() => {
      this.draw_map();
    });
  },
  methods: {
    //定义方法 draw_map 绘制中国地图
    draw_map() {
      this.myChart = this.$echarts.init(document.getElementById("map_cn"));

      this.myChart.off("click");

      bus.$on("mapBus", (mapData) => {
        // console.log(mapData) //componentA参数
        this.myChart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
        });
        this.myChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: mapData.city_id,
        });
        this.myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: mapData.city_id,
        });
      });

      //显示地图
      this.myChart.setOption(this.option);

      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },

    //修改echart配制
    setEchartOption() {
      this.option.series[0].data = this.dataList;
    },

    mapBgimg() {
      if (this.$route.path == "/styj") {
        // console.log('生态宜居');
        this.Bgimg =
          "https://www.bjdzhl.com/app/getFileURL/file/pages/map/ss.png";
      } else if (this.$route.path == "/cyxw") {
        // console.log('产业兴旺');
        this.Bgimg =
          "https://www.bjdzhl.com/app/getFileURL/file/pages/map/ny.png";
      } else if (this.$route.path == "/xfwm") {
        // console.log('乡风文明');
        this.Bgimg =
          "https://www.bjdzhl.com/app/getFileURL/file/pages/map/ly.png";
      } else if (this.$route.path == "/zlyx") {
        // console.log('治理有效');
        this.Bgimg =
          "https://www.bjdzhl.com/app/getFileURL/file/pages/map/xz.png";
      } else if (this.$route.path == "/shfy") {
        // console.log('生活富裕');
        this.Bgimg =
          "https://www.bjdzhl.com/app/getFileURL/file/pages/map/jt.png";
      }
    },
  },
  created() {
    this.setEchartOption();
  },
  computed: {
    bgStyle() {
      return {
        backgroundImage: "url(" + this.Bgimg + ")",
      };
    },
  },
};
</script>
 
<style scoped lang="less">
.content {
  position: relative;
  margin: 0 0 0 -3%;
  width: 43vw;
  height: 87vh;

  .DTimg {
    margin: auto;
    width: 40vw;
  }

  .map_cn {
    width: 100%;
    height: 96%;
    z-index: 2;
    // background: url({{this.Bgimg}}) no-repeat;
    background-size: contain;
    // background-position: 1vh 0.5vh;
    background-position: center center;
    background-repeat: no-repeat;
    // background-color: rgba(172, 172, 172, 0.705);
  }
  .map_but {
    position: absolute;
    right: 8%;
    bottom: 0;
    color: #333;
    font-weight: 900;
    border-radius: 5px;
    cursor: pointer;
    z-index: 10;
    padding: 1%;
    font-size: calc(100vw * 16 / 1920);
    font-weight: 1000;
  }
  .map_but:hover {
    color: rgb(30, 116, 255);
  }
}
</style>